'use client'

/**
 * Associates the authenticated user with their active PostHog tenant group.
 * Must be rendered inside TenantProvider (i.e. within DashboardShell).
 */

import { useEffect, useRef, useState } from 'react'
import posthog from 'posthog-js'
import { useTenant } from './tenant/TenantProvider'
import { isPostHogReady, onPostHogReady } from '@auctogon/admin-isomorphic/isomorphic/posthog-state'

export default function PostHogTenantGroup() {
  const { currentTenant } = useTenant()
  const lastTenantId = useRef<string | null>(null)
  // React fires effects bottom-up (children before parents), so PostHogInit's
  // effect may not have run yet on the first render. Track readiness locally
  // and re-run grouping once PostHog becomes ready.
  const [isReady, setIsReady] = useState(isPostHogReady)

  useEffect(() => {
    if (isReady) return
    return onPostHogReady(() => setIsReady(true))
  }, [isReady])

  useEffect(() => {
    if (!isReady) return
    if (!currentTenant) return
    if (currentTenant.id === lastTenantId.current) return
    posthog.group('tenant', currentTenant.id, { name: currentTenant.name })
    lastTenantId.current = currentTenant.id
  }, [currentTenant, isReady])

  return null
}
